export default __webpack_public_path__ + "static/media/205.5f2e6689.png";